import Dialog from '@mui/material/Dialog'
import Box from '@mui/material/Box'
import { Link, Typography } from '@mui/material'

import Button from 'components/Common/Button'
import { PRIMARY_BUTTON } from 'themes/theme'

const sx = {
  dialogContainer: {
    textAlign: 'center',
    color: 'rgb(22,21,84)',
    padding: '20px',
  }
}

const PaymentFailModal = ({ open, onClose }) => {
  return (
    <Dialog sx={sx.dialogContainer} hideBackdrop open={open} onClose={onClose}>
      <div className="p-4">
        <div className="d-flex flex-column">
          <Typography variant='body2' color='primary' className="container-fluid text-start text-break lead mb-1">
            We were unable to process your card. Please try a different payment source or contact your card issuer for
            more information. Still have questions?{' '}
            <Link target="_blank" href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`} sx={{ color: '#0A78CD', fontWeight: 'bold', fontFamily: 'poppins', textDecoration: 'none' }}>
              Get help
            </Link>
          </Typography>
        </div>
        <Box className="d-flex align-items-center justify-content-end h-100 mt-5">
          <Button type={PRIMARY_BUTTON} onClick={onClose}>
            Ok
          </Button>
        </Box>
      </div>
    </Dialog>
  )
}

export default PaymentFailModal
